// '+' 별칭(user+tag@gmail.com)과 6자 넘는 TLD(.company 등)도 정상 이메일로 인식하도록 통일된 정규식
const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const isValidEmail = (email?: string | null): boolean => {
  if (!email) return false;
  return EMAIL_REGEX.test(email);
};
